export const model = {
    from: { name: 'from' },
    destination: { name: 'destination' },
    dates: { name: 'dates' },
}
